import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';
import { saveAs } from 'file-saver';
/**
 * In this component,doctor can access patient appointment details,check payment information
 * and download patient uploaded files.
 */
@Component({
  selector: 'app-doctor-appointmentid',
  templateUrl: './doctor-appointmentid.component.html',
  styleUrls: ['./doctor-appointmentid.component.css']
})
export class DoctorAppointmentidComponent implements OnInit {

  app_Id ;
  getInfo:any;
  constructor(private route:ActivatedRoute,private getAppointmentDetails: TalkToDoctorService) { }

  ngOnInit(): void {
    this.app_Id = this.route.snapshot.paramMap.get('id');
    let obj ={
      appointmentId:+this.app_Id
    }
     this.getAppDetails(obj)
    
  }
  getAppDetails(id){
    this.getAppointmentDetails.doctorAppointmentDetails(id).subscribe(res =>{
         this.getInfo =res;
    },err =>{

    })
  }


  getFileId(id){
    this.getAppointmentDetails.downloadDoctorFile(id).subscribe( res =>{
      saveAs(res, id.fileName);
    })
  }
}
